import { useEffect } from 'react';
import '@/App.css';
import MobileNav from '@/components/MobileNav';
import HeroJourney from '@/components/HeroJourney';
import CristianSection from '@/components/CristianSection';
import Stats from '@/components/Stats';
import VideoSection from '@/components/VideoSection';
import Testimonials from '@/components/Testimonials';
import Products from '@/components/Products';
import Footer from '@/components/Footer';
import Concierge from '@/components/Concierge';
import { initLenis } from '@/hooks/useLenis';
import { useHeroMode } from '@/hooks/useHeroMode';

export default function App() {
  const mode = useHeroMode();
  useEffect(() => {
    initLenis(mode === 'immersive');
  }, [mode]);
  return (
    <div id="top" className="grain relative min-h-screen bg-noir text-cream">
      <MobileNav />
      <main>
        <HeroJourney />
        <CristianSection />
        <Stats />
        <VideoSection />
        <Testimonials />
        <Products />
      </main>
      <Footer />
      <Concierge />
    </div>
  );
}
